import { isEmpty, get } from 'lodash'
import moment from 'moment'

const kind = {
  exam: 'Exame',
  attendance: 'Consulta',
  others: 'Outros'
}

const prepareShow = function (price) {
  if (isEmpty(price.professional_id) && this.userIsCompany) {
    price.professional = {
      name: 'Todos'
    }
    // definindo nome como todos para company
    this.professional_small_name = 'Todos'
  }
  if (isEmpty(price.professional_id) && !this.userIsCompany) {
    price.professional = {
      name: this.user.name
    }
    this.professional_small_name = this.user.name.slice(0, 20) + '...'
  }
  price.covenant = get(price, 'covenant.name', 'Particular')
  price.validity = moment(price.validity).format('DD/MM/YYYY')
  price.kind = get(kind, price.kind, price.kind)
  price.value = price.value.toFixed(2).replace('.', ',')

  return price
}

export default {
  prepareShow,
  prepareSearch (search) {
    const date = moment(search.generic, 'DD/MM/YYYY')
    if (date.isValid() && date.format('DD/MM/YYYY') === search.generic) {
      search.validity = date.format('YYYY-MM-DD')
      delete search.generic

      return search
    }

    search.address = search.generic
    delete search.generic

    return search
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/index/resources/methods.js